import React from "react";
import { useTranslation } from "react-i18next";

import { DatePicker } from "antd";

import WPButton from "../WPButton";
import WPInputLabel from "../WPInputLabel";

import { DATE_FORMATS } from "../../constants/global.constants";
import { DATE_RANGE_ACTIONS } from "../../constants/LicenseManagement.constants";

import { combineClassNames } from "../../utils/appUtils";

import "./WPRangePicker.scss";

const { RangePicker } = DatePicker;

export const CustomFooter = ({
  onFooterBtnClick,
  disableClearBtn,
  disableApplyBtn,
}) => {
  const { t } = useTranslation();

  const handleApplyFilter = () => onFooterBtnClick(DATE_RANGE_ACTIONS.apply);
  const handleClearFilter = () => onFooterBtnClick(DATE_RANGE_ACTIONS.clear);

  return (
    <div className="range-picker-footer">
      <WPButton
        id="apply-button"
        customClass="apply-btn"
        variant="contained"
        onClick={handleApplyFilter}
        disabled={disableApplyBtn}
      >
        {t("apply")}
      </WPButton>
      <WPButton
        id="clear-button"
        customClass="clear-btn"
        variant="text"
        onClick={handleClearFilter}
        disabled={disableClearBtn}
      >
        {t("ValueStrings.clear")}
      </WPButton>
    </div>
  );
};

const WPRangePicker = ({
  label,
  value,
  onChange,
  required,
  className,
  wrapperClassName,
  containerClassName,
  calendarPanel = false,
  dataTestId,
  disabledDate,
  picker = "date",
  size = "middle",
  disabled = false,
  allowClear = true,
  placement = "bottomRight",
  format = DATE_FORMATS.MM_DD_YYYY,
  placeholder,
  showExtraFooter = false,
  onFooterBtnClick,
  disableClearBtn = false,
  disableApplyBtn = false,
}) => {
  const { t } = useTranslation();
  const defaultPlaceholder = [
    t("licenseManagement.startDate"),
    t("licenseManagement.endDate"),
  ];
  const handleRenderExtraFooter = () => (
    <CustomFooter
      onFooterBtnClick={onFooterBtnClick}
      disableClearBtn={disableClearBtn}
      disableApplyBtn={disableApplyBtn}
    />
  );

  return (
    <div
      className={combineClassNames(
        "wp-range-picker-container",
        containerClassName,
      )}
    >
      {label && (
        <WPInputLabel required={required} label={label} disabled={disabled} />
      )}
      <div
        className={combineClassNames(
          "wp-range-picker-wrapper",
          wrapperClassName,
        )}
      >
        <RangePicker
          value={value}
          onChange={onChange}
          disabled={disabled}
          format={format}
          placeholder={placeholder || defaultPlaceholder}
          allowClear={allowClear && !disabled}
          picker={picker}
          size={size}
          disabledDate={disabledDate}
          aria-label={label || "Range Picker"}
          className={combineClassNames(
            "wp-range-picker",
            className,
            calendarPanel && "calendar-panel-hidden",
          )}
          getPopupContainer={() => document.body}
          data-test-id={dataTestId}
          placement={placement}
          renderExtraFooter={
            showExtraFooter ? handleRenderExtraFooter : undefined
          }
          open={calendarPanel || undefined}
          inputReadOnly={calendarPanel}
        />
      </div>
    </div>
  );
};

export default WPRangePicker;
